import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, Button, cls } from '../../packages/components';
import './styles/states.scss';

const AAFModalStates = (props = {}) => {

    const ContentStates = () => {
        return (
            <Row className={cls(props.device, 'aaf-modal-state-container')}>
                {props.options.map((s) => {
                    return (
                        <Button
                            key={s.id}
                            activate
                            type="button"
                            className={cls('focusable', 'modal-button-states')}
                            onClick={(e) => props.handleClose(e, props.service(s.id))}
                        >
                            {s.name}
                        </Button>
                    );
                })}
            </Row>
        );
    };
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: false,
    };
    return (
        <ModalWrapper {...p}>
            <ContentStates />
        </ModalWrapper>
    );
};

AAFModalStates.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalStates);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalStates.jsx